import { Link } from "react-router-dom";
import { Logo } from "@/components/Navbar";

export function AuthShell({ title, subtitle, mascot, children, footer }) {
  return (
    <div className="min-h-screen mesh-warm flex flex-col">
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6">
        <Logo />
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="w-full max-w-md">
          <div className="text-center mb-6">
            {mascot && <img src={mascot} alt="Solange" className="w-24 h-24 rounded-full object-cover border-2 border-[#c17f3e] bg-white mx-auto animate-float-slow" />}
            <h1 className="mt-5 font-display text-3xl font-bold text-[#9c5f27]">{title}</h1>
            {subtitle && <p className="mt-2 text-[#5c4634]">{subtitle}</p>}
          </div>
          <div className="rounded-3xl bg-white border border-[#e8d8c8] shadow-sm p-7">
            {children}
          </div>
          {footer && <div className="mt-5 text-center text-sm text-[#5c4634]">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export function AuthField({ label, testid, type = "text", ...props }) {
  return (
    <label className="block">
      <span className="block text-sm font-medium text-[#5c4634] mb-1.5">{label}</span>
      <input
        type={type}
        data-testid={testid}
        className="w-full rounded-xl border border-[#e8d8c8] bg-white px-4 py-3 text-[#2e1e10] outline-none focus:border-[#f0791f] focus:ring-2 focus:ring-[#f0791f]/20 transition"
        {...props}
      />
    </label>
  );
}
